import { cn } from "@omni/utils/styles";
import { MouseEvent, ReactNode, useState } from "react";

import { useOverlayContext } from "@/components/General/Overlay/context/overlay.context";

type Props = {
    positionAtMount?: boolean;
    className?: string;
    children?: ReactNode;
};

export const Content = ({ positionAtMount, className, children }: Props) => {
    const { open, backdrop, overlayHeader, mountElementRef, onClose } =
        useOverlayContext();

    const [isTransitioning, setIsTransitioning] = useState<boolean>(false);

    const handleOnChildClick = (event: MouseEvent) => {
        event.stopPropagation();
    };

    const handleOnOverlayClick = (event: MouseEvent<HTMLDivElement>) => {
        onClose(event);
    };

    const handleOnTransitionStart = () => {
        if (!open) return;
        setIsTransitioning(true);
    };

    const handleOnTransitionEnd = () => {
        if (open) return;
        setIsTransitioning(false);
    };

    const mountY = mountElementRef.current?.getBoundingClientRect().y;

    return (
        <div
            className={cn(
                "tw:fixed tw:top-0 tw:left-0 tw:h-screen tw:w-screen tw:pointer-events-none",
                {
                    "tw:layer-modal/[1]":
                        (open || isTransitioning) && overlayHeader,
                    "tw:layer-overlay/[1]":
                        (open || isTransitioning) && !overlayHeader,
                    "tw:layer-base/[0]": !open && !isTransitioning,
                    "tw:invisible": !open
                }
            )}
        >
            <div className={cn("tw:relative tw:w-full tw:h-dvh")}>
                <div
                    className={cn(
                        "tw:absolute tw:w-full tw:h-full tw:z-0",
                        {
                            "tw:transition-opacity tw:bg-black": backdrop
                        },
                        {
                            "tw:pointer-events-auto tw:opacity-50": open,
                            "tw:pointer-events-none tw:opacity-0": !open
                        }
                    )}
                    onClick={handleOnOverlayClick}
                    onTransitionStart={handleOnTransitionStart}
                    onTransitionEnd={handleOnTransitionEnd}
                />
                <div
                    className={
                        "tw:absolute tw:w-full tw:h-full tw:z-10 tw:pointer-events-none"
                    }
                    style={
                        positionAtMount
                            ? {
                                  marginTop: `${mountY}px`,
                                  height: `calc(100dvh - ${mountY}px)`
                              }
                            : undefined
                    }
                >
                    <div
                        className={cn(
                            "tw:pointer-events-auto",
                            { "tw:hidden": !open },
                            className
                        )}
                        onClick={handleOnChildClick}
                    >
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};
